import { Box, ColorOptions, convertHexToRGBA, Text, TextInput } from '@jfs/ui-new'
import { useRef, useState } from 'react'
import { TextInput as RNTextInput } from 'react-native'
import { Colors } from '../../../../util/util'

export const TextInputWithLabelOnBorder = ({
  setFieldValue,
  fieldName,
  label,
  leftComponent,
  rightComponent,
  maxLength,
  height = 64,
  onFocus,
  onBlur,
  textWrapperStyles,
  ...props
}) => {
  const [isFocussed, setFocused] = useState(false)

  const textRef = useRef<RNTextInput>()
  const onChangeText = (val) => {
    if (fieldName && setFieldValue) {
      setFieldValue(fieldName, val)
    }
  }

  const onInternalFocus = () => {
    setFocused(true)
    if (onFocus) {
      onFocus()
    }
  }
  const onInternalBlur = () => {
    setFocused(false)
    if (onBlur) {
      onBlur()
    }
  }

  return (
    <Box pt={11}>
      <Box position={'absolute'} zIndex={1} top={0} bg={'WHITE'} left={16} h={24} ph={3}>
        <Text
          title={label}
          fontSize={14}
          fontFamily={'JioType-Medium'}
          lineHeight={24}
          color={Colors.BLACK_14 as ColorOptions}
        />
      </Box>

      <Box
        h={height}
        borderWidth={1}
        ph={16}
        borderRadius={8}
        borderColor={isFocussed ? Colors.PRIMARY : ('#B5B5B5' as ColorOptions)}
        justify={'center'}
        {...textWrapperStyles}>
        <TextInput
          innerRef={textRef}
          onFocus={onInternalFocus}
          onBlur={onInternalBlur}
          onChangeText={onChangeText}
          minHeight={56}
          rightComponent={rightComponent}
          leftComponent={leftComponent}
          showBottomLine={false}
          fontFamily={'JioType-Medium'}
          fontWeight={'600'}
          fontSize={24}
          placeholderTextColor={props?.placeholderTextColor ?? (convertHexToRGBA(Colors.BLACK_14, 50) as ColorOptions)}
          color={Colors.BLACK_14 as ColorOptions}
          maxLength={maxLength}
          touched={true}
          keyboardType={fieldName === 'email' ? "email-address": 'default'}
          {...props}
          error={undefined}
        />
      </Box>
    </Box>
  )
}
